import React, { useEffect } from 'react';
import {} from '../../util/ContractAdminUtils';

const CASummaryEntSecondSectInfo = prodData => {
  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <div className="ent-section-header">
        <div className="ent-section-header-col1 ">
          <span className="summary-pd-col">Product Deliverable</span>
        </div>
        <div className="ent-section-header-col2">Seat Max</div>
      </div>
      <div className="ent-info-first-sec-colums">
        <div className="prod-section">
          {prodData.prodData.map((prod, i) => {
            return (
              <div>
                {prod.selected && (
                  <div className="prod-section-header">
                    <div className="prod-section-header-col1">
                      {prod.optionName}
                    </div>
                    <div className="prod-section-header-col2">
                      {prod.maxSeats}
                    </div>
                  </div>
                )}
                {prod.modules &&
                  prod.modules.map((item, i) => {
                    return (
                      <div className="access-prod-list ">
                        <span>{item.selected && item.optionName} </span>{' '}
                        {item.modules &&
                          item.modules.map((i1, i) => (
                            <div className="access-prod-list ">
                              {i1.selected && i1.optionName}
                            </div>
                          ))}
                      </div>
                    );
                  })}
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CASummaryEntSecondSectInfo;
